import { Component } from '@angular/core';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-widget-empty',
  templateUrl: './widget-empty.component.html',
  styleUrl: './widget-empty.component.scss',
  standalone: true,
  imports: [SHARED_IMPORTS]
})
export class WidgetEmptyComponent {}
